import styled from "@emotion/styled";
import {  Col, Row, Typography } from "antd";
import { FC } from "react";
import { numberFormat } from "utils/nuberFormat";

interface MainCreatePriceTransportationProps {
    servicePrice: number;
}

const MainCreatePriceTransportation: FC<MainCreatePriceTransportationProps> = ({
    servicePrice
}) => {
  return (
    <>
    <FormWrapper>
      <FormItemWrapper>
        <HeadWrapper>
          {/* <Typography.Text 
            style={{
              fontWeight: 600,
            }}
            underline >ค่าจัดส่ง</Typography.Text> */}
        </HeadWrapper>
        <Row style={{ backgroundColor: "#FFFFFF" }}>
            <Col span={24}>
                <Typography.Title level={5} style={{ padding: 10, display: "flex", justifyContent: "flex-end" }}>
                จำนวนค่าส่ง: {numberFormat(servicePrice)} บาท
                </Typography.Title>
            </Col>
        </Row>
      </FormItemWrapper>
    </FormWrapper>
  </>
  );
};

export default MainCreatePriceTransportation;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffffff;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0px 10px 0px 10px;
`;


const FormItemWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px 0px 10px 0px;
  border-radius: 10px;
`;
